import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CalculatorComponent} from './calculator.component';
import {CalculatorRoutingModule} from './calculator-routing.module';
import {CalculateBoxComponent} from './components/calculate-box/calculate-box.component';
import {ExampleTaxComponent} from './components/example-tax/example-tax.component';
import {InputNumberModule} from './components/input-number/input-number.module';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TemplateSlotModule} from '../../../shared/components/template-slot/template-slot.module';
import {DropdownComponent} from './components/dropdown/dropdown.component';
import { NumberOnlyModule } from 'src/app/shared/directives';


@NgModule({
  declarations: [
    CalculatorComponent,
    CalculateBoxComponent,
    ExampleTaxComponent,
    DropdownComponent
  ],
  exports: [],
  imports: [
    CommonModule,
    CalculatorRoutingModule,
    InputNumberModule,
    NgbDropdownModule,
    ReactiveFormsModule,
    TemplateSlotModule,
    FormsModule,
    NumberOnlyModule
  ]
})
export class CalculatorModule {
}
